import "./BottomSection.css";

export const BottomSection = () => {
  return (
    <>
      <div className="bottom-section">
        <div className="image-container">
          <img
            className="ncount-img"
            src="./assets/ncount-logo.png"
            alt="ncount-logo"
          />
        </div>
        <div className="image-container">
          <img src="./assets/heureka-logo.png" alt="heureka-logo" />
        </div>
      </div>
    </>
  );
};
